import React, { useEffect } from 'react';
import { TextField } from '@material-ui/core';
import { useForm } from '../../../../../../../../../hooks/useForm';
import NumberFormat from 'react-number-format'; 

const IncomeNotConsidered = ({ notConsideredIncomes, setFormValuesDetailsSummary }) => {

  const { formValues, setFormValues } = useForm({
    isrRetaineds: 0.00,
    ivaRetaineds: 0.00,
    ivaTranslateds: 0.00,
    subtotal: 0.00,
    total: 0.00,
    totalIVATraslateds: {},
    totalISRRetaineds: {},
    totalIVARetaineds: {},
  });

  const { isrRetaineds, ivaRetaineds, ivaTranslateds, subtotal, total, totalISRRetaineds, totalIVARetaineds, totalIVATraslateds,  } = formValues;

  useEffect(() => {
    let totalSum = 0.00;
    let subtotalSum = 0.00;
    let ivaTrasSum = 0.00;
    let ivaRetSum = 0.00;
    let isrRetSum = 0.00;
    if (notConsideredIncomes.length > 0) {
      notConsideredIncomes.forEach((income, i) => {
        totalSum = (parseFloat(totalSum) + parseFloat(income.total)).toFixed(2);
        subtotalSum = (parseFloat(subtotalSum) + parseFloat(income.subTotal)).toFixed(2)

        let totalIvaTras = 0.00;
        let totalIsrRet = 0.00;
        let totalIvaRet = 0.00;

        income.concepts.forEach((concept) => {
          if(concept.impuestos && concept.impuestos.traslados){
            concept.impuestos.traslados.forEach(taxe => {
              if (taxe.impuesto === '002') {
                totalIvaTras = (parseFloat(totalIvaTras) + parseFloat(taxe.importe)).toFixed(2);
              }
            })
          }
          if(concept.impuestos && concept.impuestos.retenciones){
            concept.impuestos.retenciones.forEach((taxe) => {
              if (taxe.impuesto === '002') {
                totalIvaRet = (parseFloat(totalIvaRet) + parseFloat(taxe.importe)).toFixed(2);
              }
              if (taxe.impuesto === '001') {
                totalIsrRet = (parseFloat(totalIsrRet) + parseFloat(taxe.importe)).toFixed(2);
              }
            })
          }
        })

        ivaTrasSum = (parseFloat(ivaTrasSum) + parseFloat(totalIvaTras)).toFixed(2);
        ivaRetSum = (parseFloat(ivaRetSum) + parseFloat(totalIvaRet)).toFixed(2);
        isrRetSum = (parseFloat(isrRetSum) + parseFloat(totalIsrRet)).toFixed(2);

        setFormValues(prevState => {
          return{
            ...prevState,
            totalIVATraslateds: {
              ...prevState.totalIVATraslateds,
              [i]: totalIvaTras
            },
            totalISRRetaineds: {
              ...prevState.totalISRRetaineds,
              [i]: totalIsrRet
            },
            totalIVARetaineds: {
              ...prevState.totalIVARetaineds,
              [i]: totalIvaRet
            }
          }
        })
      });
      setFormValues(prevState => {
        return{
          ...prevState,
          isrRetaineds: isrRetSum,
          ivaRetaineds: ivaRetSum,
          ivaTranslateds: ivaTrasSum,
          subtotal: subtotalSum,
          total: totalSum
        }
      })
    }else{
      setFormValues(prevState => {
        return{
          ...prevState,
          isrRetaineds: 0.00,
          ivaRetaineds: 0.00,
          ivaTranslateds: 0.00,
          subtotal: 0.00,
          total: 0.00
        }
      })
    }
    setFormValuesDetailsSummary(prevState => {
      return{
        ...prevState,
        totalIncomesNotAutorized: totalSum
      }
    })
  }, [notConsideredIncomes, setFormValues, setFormValuesDetailsSummary])

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
        <div className="card">
          <div className="card-header">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h5>Ingresos No Considerados</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Fecha de cobro</th>
                <th>Cliente</th>
                <th>Concepto</th>
                <th>Folio</th>
                <th>Subtotal</th>
                <th>IVA</th>
                <th>IVA Retenido</th>
                <th>ISR Retenido</th>
                <th>Total recibido</th>
              </tr>
            </thead>
            <tbody>
              {
                notConsideredIncomes.map((notConsidered, index) => {
                  return (
                    <tr key={ index } className="text-center">
                      <td> { notConsidered.paymentAt } </td>
                      <td>
                        {notConsidered.receivedRfc}
                        <br />
                        {notConsidered.receivedFullName}
                      </td>
                      <td>
                        <TextField
                          label="Concepto" variant="outlined" size="small" autoComplete="off" fullWidth={ true }
                          select
                          SelectProps={{
                            native: true,
                          }}
                          readOnly
                        >
                          {
                            notConsidered.concepts.map((concept, i) => {
                              return (
                                <option
                                  key={ i }
                                >
                                  { concept.claveProdServ ? `${ concept.claveProdServ } - ` : '' } 
                                  { concept.descripcion }
                                </option>
                              )
                            })
                          }
                        </TextField>
                      </td>
                      <td>{ notConsidered.folio }</td>
                      <td><NumberFormat value={parseFloat(notConsidered.subTotal).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                      <td><NumberFormat value={parseFloat(totalIVATraslateds[index]).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                      <td><NumberFormat value={parseFloat(totalIVARetaineds[index]).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                      <td><NumberFormat value={parseFloat(totalISRRetaineds[index]).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                      <td><NumberFormat value={parseFloat(notConsidered.total).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                    </tr>
                  )
                })
              }
               <tr className="text-center">
                <td colSpan="4" className="text-right"><strong>Totales</strong></td>
                <td><NumberFormat value={parseFloat(subtotal).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                <td><NumberFormat value={parseFloat(ivaTranslateds).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                <td><NumberFormat value={parseFloat(ivaRetaineds).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                <td><NumberFormat value={parseFloat(isrRetaineds).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                <td><NumberFormat value={parseFloat(total).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default IncomeNotConsidered;